export function determineBackground(addonSheet, backgrounds) {
  const { addon: { cssName } } = addonSheet;

  return backgrounds.find((bg) => bg.productTypeNames?.includes(cssName)) || backgrounds[0];
}
